<template>
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <drop-down
        v-if="anyChecked"
        :items="checkedActions"
        class="actions-dropdown pt-2 text-black"
        normal-size
        always-show-dropdown
      />
    </page-header>

    <div
      v-if="showCaatAssignment && isDetailTab"
      class="py-4 px-4 bg-light-gray mb-3"
    >
      <caat-assignment
        :equipment-ids="checkedIds"
        @close="() => onSearchHandler()"
      />
    </div>
    <board class="mb-4" :details="boardDetails">
      <template #data-item="{ item }">
        <div v-if="!item.data">
          <custom-balloon
            :background-color="item.statusColor"
            :text="item.statusName"
            dot
          />
        </div>
      </template>
    </board>

    <div class="mb-4">
      <q-tab :active-tab="activeTab">
        <q-tab-item
          :lazy="loadComponent(key)"
          v-for="(tab, key) in tabs"
          :key="key"
          :title="tab.title"
          :has-error="!tab.valid"
          :visible="tab.visible"
          :nav-item-class="tab.classes"
          @click="setCurrentTab(key)"
        >
          <component
            :key="tabKey"
            :inventory-catalog-id="inventoryCatalogId"
            :is-read-only="isReadOnly"
            :is="tab.id"
            :ref="tab.id"
            :code="tab.id"
            :data="tab.data"
            :inventory="inventory"
            @loaded="setTabLoaded"
          ></component>
        </q-tab-item>
      </q-tab>
    </div>
    <div v-if="canViewResultSection">
      <filter-manager
        ref="filter"
        v-model="filter.model"
        :filters="filtersHeader"
        class="filter-manager_extended"
        search-container-class="search-btn"
        @search="onSearchHandler()"
        @brand="getModels"
      />
      <div class="row my-3" v-if="showChecks">
        <div class="col-12">
          <checkbox
            checked-bg-color="bg-success"
            icon="fal fa-check"
            :text="allCheckedText"
            class="d-flex justify-content-end text-green"
            v-model="allChecked"
            @input="checkAll"
          />
        </div>
      </div>
      <custom-separator
        class="my-3 custom-separator"
        text="Listado de Equipos"
      />
      <div v-if="hasResults">
        <template v-if="isDetailTab">
          <result-row
            v-for="(item, index) in results"
            :key="index"
            :item="item"
            :checkable="showChecks"
            :can-view-status-summary="isDetailTab"
            @open="handlerOpen"
            @close="handlerClose"
            @refresh="refresh"
            @check="onCheckItem"
            :is-caat-alert-activated="isMissingCaatAlertActivated"
          />
        </template>
        <template v-if="isSummaryTab">
          <result-row-summary
            v-for="(item, index) in results"
            :key="index"
            :item="item"
            :can-view-status-summary="isDetailTab"
            @open="handlerOpen"
            @close="handlerClose"
            @refresh="refresh"
          />
        </template>

        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
      <custom-result-not-found v-else text="No hay Información Disponible." />
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import Checkbox from 'CheckBox';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import mixAlert from '@/mixins/alert.mixin';
import { date } from '@/utils/filters';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import CustomBalloon from 'custom-balloon';
import TABS from '@/utils/constants/inventoryManagementTabs';
import { Dashboard, Summary, Detail, Property, Accessory } from './tabs';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import locationService from '@/services/api/location.api';
import ResultRow from './components/ResultRow.vue';
import ResultRowSummary from './components/ResultRowSummary.vue';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import peiAtServiceEquipmentStatus from '@/utils/constants/peiAtServiceEquipmentStatus';
import equipmentsActionType from '@/utils/constants/peiAtServiceEquipmentsActionType';
import CaatAssignment from './components/CaatAssignment';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
const DEFAULT_PAGE_SIZE = 5;

const INVENTORY_MAINTENANCE_ROUTE_NAME = 'inventoryMaintenance';

export default {
  components: {
    PageHeader,
    Board,
    QTab,
    QTabItem,
    ActionButton,
    DropDown,
    CustomBalloon,
    Checkbox,
    Dashboard,
    Summary,
    Detail,
    Property,
    Accessory,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
    ResultRowSummary,
    CaatAssignment,
  },
  mixins: [mixAlert, storeMixin],
  data: () => ({
    showCaatAssignment: false,
    inventory: {},
    activeTab: TABS.Dashboard,
    tabKey: 0,
    loading: false,
    tabsLoaded: [
      { id: TABS.Dashboard, lazy: true, loaded: false, visible: true },
    ],
    filter: {
      model: {
        equipment: null,
        status: null,
        caat: null,
        code: null,
        brand: null,
        model: null,
        color: null,
        size: null,
      },
      options: {
        equipments: [],
        statuses: [],
        caats: [],
        brands: [],
        models: [],
        colors: [],
        sizes: [],
      },
    },
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: DEFAULT_PAGE_SIZE,
    },
    results: [],
    allChecked: false,
    allCheckedIgnoreCallback: false,
    isMissingCaatAlertActivated: false,
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    isSummaryTab() {
      return this.activeTab == TABS.Summary;
    },
    isDetailTab() {
      return this.activeTab == TABS.Detail;
    },
    canViewResultSection() {
      return [TABS.Summary, TABS.Detail].includes(this.activeTab);
    },
    canViewSaveButton() {
      return [TABS.Property, TABS.Accessory].includes(this.activeTab);
    },
    loadComponent() {
      return (tab) => {
        const item = this.tabsLoaded
          .filter((x) => x.visible)
          .find((x) => x.id == tab);
        return item?.lazy;
      };
    },
    inventoryCatalogId() {
      return Number(this.$route.params.id);
    },
    tabParam() {
      if (this.$route.query.tab) return Number(this.$route.query.tab);
      return TABS.Dashboard;
    },
    headerPage() {
      return {
        icon: 'fas fa-laptop',
        title: `Administración Inventario: ${this.inventory.name}`,
        routes: [
          'Inventario',
          'Mantenimiento del Catálogo de Equipos de Asistencia Tecnológica',
        ],
      };
    },
    hasResults() {
      return Boolean(this.results?.length);
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'equipmentMaintenance' }),
        },
        {
          text: 'Cargar Equipos',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: () => this.addEquipment(),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          visible: this.canViewSaveButton,
          click: () => this.handleSubmit(),
        },
      ];
    },
    filtersHeader() {
      return [
        {
          name: 'equipment',
          component: 'CustomDropDown',
          options: this.filter.options.equipments,
          value: this.filter.model.equipment,
          placeholder: 'Equipo',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
        },
        {
          name: 'caat',
          component: 'CustomDropDown',
          options: this.filter.options.caats,
          value: this.filter.model.caat,
          placeholder: 'CAAT',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          disabled: this.filter?.options?.caats?.length == 1,
        },
        {
          name: 'code',
          component: 'CustomInput',
          value: this.filter.model.code,
          placeholder: 'Escriba Código de Equipo',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md',
          type: 'text',
        },
        {
          name: 'brand',
          label: 'Marca:',
          component: 'CustomDropDown',
          value: this.filter.model.brand,
          options: this.filter.options.brands,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
        },
        {
          name: 'model',
          label: 'Modelo:',
          component: 'CustomDropDown',
          value: this.filter.model.model,
          options: this.filter.options.models,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
        },
        {
          name: 'color',
          label: 'Color:',
          component: 'CustomDropDown',
          value: this.filter.model.color,
          options: this.filter.options.colors,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
        },
        {
          name: 'size',
          label: 'Tamaño:',
          component: 'CustomDropDown',
          value: this.filter.model.size,
          options: this.filter.options.sizes,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
        },
      ];
    },
    showNotResults() {
      return this.result.length == 0;
    },
    boardDetails() {
      return [
        [
          {
            label: 'Nombre de Equipo MiPE:',
            icon: 'fas fa-file',
            data: `${this.inventory.name}`,
            cols: 'col-12 col-md-3 pt-2',
          },
          {
            label: 'Estatus:',
            icon: 'fas fa-file-lines',
            statusColor: this.inventory.statusColor,
            statusName: this.inventory.statusName,
            cols: 'col-12 col-md-3 pt-2',
          },
          {
            label: 'Categoría de Cumplimiento:',
            icon: 'fas fa-file-alt',
            data: this.inventory.classification?.name,
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Última Fecha de Inventario:',
            icon: 'fas fa-calendar-minus',
            data: date(this.inventory.lastDate),
            cols: 'col-12 col-md pt-2',
          },
        ],
      ];
    },
    isReadOnly() {
      return false;
    },
    tabs() {
      const allTabs = [
        {
          id: 'Dashboard',
          title: 'Dashboard',
          valid: true,
          visible: true,
          data: {},
        },
        {
          id: 'Summary',
          title: 'Resumen',
          valid: true,
          visible: true,
          data: {},
        },
        {
          id: 'Detail',
          title: 'Detalles',
          valid: true,
          visible: true,
          data: {},
        },
        {
          id: 'Property',
          title: 'Propiedades',
          valid: true,
          visible: true,
          data: {},
        },
        {
          id: 'Accessory',
          title: 'Accesorios',
          valid: true,
          visible: true,
          data: {},
        },
      ];
      return allTabs;
    },
    allCheckedText() {
      return this.allChecked
        ? `Deseleccionar Todo (${this.results.filter((x) => x.checked).length})`
        : 'Seleccionar Todo';
    },
    anyChecked() {
      return this.results.some((x) => x.checked);
    },
    allProcessed() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Processed
        ) && Boolean(this.results.length)
      );
    },
    allInactivated() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Inactive
        ) && Boolean(this.results.length)
      );
    },
    allReturned() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Returned
        ) && Boolean(this.results.length)
      );
    },
    filterInactivated() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Inactive
      );
    },
    filterReturned() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Returned
      );
    },
    filterProcessed() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Processed
      );
    },
    filterAvailable() {
      return (
        this.filter.model.status?.id === peiAtServiceEquipmentStatus.Available
      );
    },
    showChecks() {
      return (
        this.isDetailTab &&
        ((this.allProcessed && this.filterProcessed) ||
          (this.allAvailable && this.filterAvailable) ||
          (this.allInactivated && this.filterInactivated) ||
          (this.allReturned && this.filterReturned))
      );
    },
    allAvailable() {
      return (
        this.results.every(
          (x) => x.statusId === peiAtServiceEquipmentStatus.Available
        ) && Boolean(this.results.length)
      );
    },
    checkedActions() {
      return [
        {
          visible: this.allProcessed || this.allInactivated || this.allReturned,
          name: 'Marca Disponibles',
          icon: 'fas fa-file-check text-green',
          click: () =>
            this.applyActionToEquipments(equipmentsActionType.MarkAvailable),
        },
        {
          name: 'Inactivar',
          icon: 'fas fa-ban text-muted',
          visible:
            (this.allProcessed || this.allAvailable) &&
            this.userHasPermissions(
              'technologyassistance.inventory.inactiveequipment'
            ),
          click: () =>
            this.applyActionToEquipments(equipmentsActionType.Inactivate),
        },
        {
          name: 'Asignar CAAT',
          icon: 'fas fa-user-plus text-green',
          click: () => this.displayCaatAssignment(),
          visible:
            (this.allProcessed || this.allAvailable) &&
            this.userHasPermissions(
              'technologyassistance.inventory.assigncaattoequipment'
            ),
        },
        {
          name: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          click: () =>
            this.applyActionToEquipments(equipmentsActionType.Eliminate),
          visible: this.userHasPermissions(
            'technologyassistance.inventory.deleteequipment'
          ),
        },
      ];
    },
    checkedIds() {
      if (this.allAvailable || this.allProcessed)
        return this.results.filter((x) => x.checked).map((x) => x.id);
      return [];
    },
  },
  created() {
    this.activeTab = this.tabParam;
  },
  async mounted() {
    await this.initData();
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    displayCaatAssignment() {
      this.showCaatAssignment = true;
    },
    hideDisplayCaatAssignment() {
      this.showCaatAssignment = false;
    },
    async handleSubmit() {
      const refs = this.tabs
        .filter((x) => x.visible)
        .map(({ id }) => this.$refs[id]);
      await refs[this.activeTab][0].save();
    },
    async initData() {
      await this.getBoardInfo();
      await this.getInventoryManagementFilters();
      if (this.tabParam) {
        this.setCurrentTab(this.tabParam);
        await this.onSearchHandler();
        this.$forceUpdate();
      } else {
        this.setCurrentTab(TABS.Dashboard);
      }
    },
    async getBoardInfo() {
      const { data } = await inventoryCatalogService.getCatalog(
        this.inventoryCatalogId
      );
      this.inventory = data;
    },
    async getInventoryManagementFilters() {
      const {
        data,
      } = await inventoryCatalogService.getInventoryManagementFilters(
        this.inventoryCatalogId
      );
      this.filter.options.equipments = data.equipment;
      this.filter.options.statuses = data.status;
      this.filter.options.caats = data.caat;
      this.filter.options.brands = data.brand;
      this.filter.options.colors = data.color;
      this.filter.options.sizes = data.size;

      if (this.filter.options.caats.length == 1) {
        this.filter.model.caat = this.filter.options.caats[0];
      }
    },
    async getModels() {
      if (!this.filter.model.brand) {
        this.filter.options.models = [];
        this.filter.model.model = null;
        return;
      }
      const { data } = await inventoryCatalogService.getCatalogModels(
        this.inventoryCatalogId,
        this.filter.model.brand.id
      );
      this.filter.options.models = data;
    },
    setTabLoaded(i) {
      if (i == undefined) {
        return;
      }
      const tab = this.tabsLoaded
        .filter((x) => x.visible)
        .find((x) => x.id == i);
      tab.lazy = false;
      tab.loaded = true;
    },
    async setCurrentTab(tab) {
      this.activeTab = tab;

      if (tab) this.$router.replace({ query: { tab } });
      else this.$router.replace({ name: this.$route.name });

      const tabsToReload = [TABS.Summary, TABS.Detail];

      if (tabsToReload.includes(tab)) {
        await this.onSearchHandler();
      }
    },
    async addEquipment() {
      this.$router.push({
        name: INVENTORY_MAINTENANCE_ROUTE_NAME,
        params: {
          id: this.inventoryCatalogId,
        },
      });
    },
    async onSearchHandler(page = 1) {
      this.hideDisplayCaatAssignment();
      this.allChecked = false;
      const {
        equipment,
        status,
        caat,
        code,
        brand,
        model,
        color,
        size,
      } = this.filter.model;

      const apiToCall = this.isSummaryTab
        ? inventoryCatalogService.getSearchEquipmentsSummary
        : inventoryCatalogService.getSearchEquipments;

      const { data } = await apiToCall(this.inventoryCatalogId, 0, {
        equipmentName: equipment?.name,
        statusId: status?.id,
        caatId: caat?.id,
        code: code,
        brandId: brand?.id,
        modelId: model?.id,
        colorId: color?.id,
        sizeId: size?.id,
        currentPage: page,
        pageSize: this.pagination.pageSize,
      });

      this.results = data.data.map((x) => ({
        ...x,
        isOpen: false,
        checked: false,
      }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async onPageChange(page) {
      this.onSearchHandler(page);
    },
    async getCaats() {
      const { data: caats } = await locationService.getCaats();
      this.filter.options.caats = caats;
      if (this.filter.options.caats.length == 1) {
        this.filter.model.caat = this.filter.options.caats[0];
      }
    },
    handlerOpen(item) {
      if (this.isSummaryTab) {
        this.results
          .filter((x) => x.key !== item.key && x.isOpen)
          .forEach((x) => (x.isOpen = false));

        item.isOpen = true;

        return;
      }

      this.results
        .filter((x) => x.id !== item.id && x.isOpen)
        .forEach((x) => (x.isOpen = false));

      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    },
    async refresh() {
      await this.onSearchHandler(this.pagination.currentPage);
    },
    checkAll() {
      if (this.allCheckedIgnoreCallback) return;
      this.results.forEach((x) => (x.checked = this.allChecked));
    },
    onCheckItem({ checked }) {
      if (checked) {
        const every = this.results.every((x) => x.checked);
        if (every) this.allChecked = true;
      } else if (this.allChecked) {
        this.allCheckedIgnoreCallback = true;
        this.allChecked = false;
        setTimeout(() => (this.allCheckedIgnoreCallback = false), 100);
      }
    },
    async applyActionToEquipments(action) {
      try {
        this.showCaatAssignment = false;
        this.isMissingCaatAlertActivated = false;
        const ids = this.results.filter((x) => x.checked).map((x) => x.id);

        const checkedEquipmentsWithoutCaat = this.results.filter(
          (x) =>
            x.checked &&
            !x.caatId &&
            (x.statusId == peiAtServiceEquipmentStatus.Processed ||
              x.statusId == peiAtServiceEquipmentStatus.Inactive)
        );

        if (action == equipmentsActionType.MarkAvailable) {
          this.isMissingCaatAlertActivated = true;

          if (checkedEquipmentsWithoutCaat.length != 0) {
            this.ShowToast(
              'Equipos sin CAAT seleccionados.',
              'Todos los equipos deben contar con CAAT asignado para poder marcarlo disponible.',
              'error'
            );
            return;
          }
        }
        let message = '¿Está seguro que desea ';
        let successMsg = '';
        switch (action) {
          case equipmentsActionType.MarkAvailable:
            message += `cambiar el estatus de (${ids.length}) equipo(s) de ${this.filter.model.status.name} a Disponible?`;
            successMsg = 'marcados disponibles';
            break;
          case equipmentsActionType.Inactivate:
            message += `cambiar el estatus de (${ids.length}) equipo(s) de Procesado a Inactivo?`;
            successMsg = 'inactivados';
            break;
          case equipmentsActionType.Eliminate:
            message += `eliminar (${ids.length}) equipo(s)?`;
            successMsg = 'eliminados';
            break;
        }
        const confirmed = await this.ShowCancelModal('Confirmación', message);
        if (!confirmed) return;
        await inventoryCatalogService.applyActionToEquipments(action, ids);

        this.ShowToast(
          'Éxito',
          `(${ids.length}) equipo(s) han sido ${successMsg} exitosamente.`,
          'success'
        );
        await this.refresh();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
  },
  beforeRouteEnter(_, from, next) {
    const routes = ['inventoryMaintenanceEquipmentDetails'];
    next(async (vm) => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onPageChange(1);
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
};
</script>
<style scoped lang="scss">
::v-deep .font-weight-bold {
  font-weight: 700 !important;
}

.actions-dropdown ::v-deep #dropdownMenuButton {
  color: #11291b !important;
}
</style>
